/* eslint-disable no-undef */

// CSS
import 'select2/dist/css/select2.min.css';
import './assets/css/main.css';
import '@complispace/cs-design-system/style.css';

import * as CSDesignSystem from '@complispace/cs-design-system';
import { translator, vuetify, axios as auth0Axios } from '@complispace/cs-design-system';

// Component imports
import { createApp, h } from 'vue';

import axios from 'axios';
import enumerable from 'linq';
import jQuery from 'jquery';
import lodash from 'lodash';
import mixpanelBrowser from 'mixpanel-browser';
import moment from 'moment-timezone';
import store2 from 'store2';
import { v4 as uuid } from 'uuid';
import eventBus from '@/lib/eventBus';
import AdministrationManagement from './components/AdministrationManagement';
import App from './App';

import ClientAdminGroupSetting from './components/ClientAdminGroupSetting';
import ClientAdminLayout from './components/ClientAdminLayout';
import ClientAdminOperationManagement from './components/ClientAdminOperationManagement';
import ClientAdminRiskCategoryManagement from './components/ClientAdminRiskCategoryManagement';
import ClientAdminRiskMatrixManagement from './components/ClientAdminRiskMatrixManagement';
import ClientAdminSiteSetting from './components/ClientAdminSiteSetting';
import ClientAdminStudentManagement from './components/ClientAdminStudentManagement';
import ClientList from './components/ClientList';
import EntityManagement from './components/EntityManagement';
import ExcursionBuilder from './components/ExcursionBuilder';
import ExcursionList from './components/ExcursionList';
import LoginCallback from './components/LoginCallback';
import PageLoadingAnimation from './components/PageLoadingAnimation';
import SafeTripBuilder from './components/SafeTripBuilder';
import SupportFeedbackLayout from './components/SupportFeedbackLayout';
import ViewPolicy from './components/ViewPolicy';
// Additional dependencies
import axiosCommon from './lib/axiosCommon';
import store from './store';
import componentOption from './lib/componentOption';
import deviceDetector from './lib/deviceDetector';
import eventPluginCommon from './lib/eventPluginCommon';
import excursionCommon from './lib/excursionCommon';
import exportExcursions from './lib/exportExcursions';
import pdf from './lib/pdf';
import routerBundle from './router/routerBundle';
// Directive imports
import safeHtmlDirective from './directives/SafeHtml';
import selectCustom from './lib/selectCustom';
import stbApi from './lib/stbApi';
// select2 needs to be initialized globally for it to work in component
import select2 from 'select2';
select2();
window.jQuery = jQuery;
window.$ = jQuery;

const app = createApp({
  render: () => h(App)
});

// Directive injections
app.directive('safe-html', safeHtmlDirective);
// Component injections
app.component('ClientAdminGroupSetting', ClientAdminGroupSetting);
app.component('ClientAdminLayout', ClientAdminLayout);
app.component('AdministrationManagement', AdministrationManagement);
app.component('ClientAdminOperationManagement', ClientAdminOperationManagement);
app.component('ClientAdminRiskCategoryManagement', ClientAdminRiskCategoryManagement);
app.component('ClientAdminRiskMatrixManagement', ClientAdminRiskMatrixManagement);
app.component('ClientAdminStudentManagement', ClientAdminStudentManagement);
app.component('ClientAdminSiteSetting', ClientAdminSiteSetting);
app.component('ClientList', ClientList);
app.component('EntityManagement', EntityManagement);
app.component('ExcursionBuilder', ExcursionBuilder);
app.component('ExcursionList', ExcursionList);
app.component('LoginCallback', LoginCallback);
app.component('PageLoadingAnimation', PageLoadingAnimation);
app.component('SafeTripBuilder', SafeTripBuilder);
app.component('SupportFeedbackLayout', SupportFeedbackLayout);
app.component('ViewPolicy', ViewPolicy);

// Additional dependency injections
const { Appcues } = window;
const env = process.env;

const eventPluginCommonAdapter = new eventPluginCommon.Adapter({
  Appcues,
  env,
  mixpanelBrowser,
  window
});

const router = routerBundle.routerComposer();

const options = {
  store,
  router,
  beforeEachRoute: routerBundle.beforeEachRoute,
  auth0: {
    appHost: window.location.host,
    appUrl: window.location.origin,
    auth0Domain: process.env.AUTH0_DOMAIN,
    auth0ClientId: process.env.AUTH0_CLIENT_ID,
    auth0Audience: process.env.AUTH0_AUDIENCE,
    appEnv: process.env.APP_ENV
  },
  gainsight: {
    gainsightSiteInfoApiHost: env.GAINSIGHT_SITE_INFO_API_HOST,
    gainsightProductTag: env.GAINSIGHT_PRODUCT_TAG,
    gainsightAppName: env.GAINSIGHT_APPNAME || 'SafeTripBuilder'
  },
  login: {
    resetBtnTimeout: 5
  }
};
app.use(CSDesignSystem, options);

const axiosInstance = store.getters['auth0/enabled'] ? auth0Axios : axios.create();
// @TODO: to revisit the axios handling
store.commit('app/setStbAxios', axiosInstance);

const stbApiAdapter = new stbApi.Adapter({
  axiosInstance,
  env
});

const globalPropertiesApp = {
  Appcues,
  axios,
  axiosCommon,
  axiosInstance,
  componentOption,
  deviceDetector,
  enumerable,
  env,
  eventBus,
  eventPluginCommonAdapter,
  excursionCommon,
  exportExcursions,
  lodash,
  mixpanelBrowser,
  moment,
  pdf,
  selectCustom,
  stbApiAdapter,
  store2,
  uuid,
  window
};
Object.defineProperty(app.config.globalProperties, '$app', { value: globalPropertiesApp });

store2({ initState: store.state });

axiosCommon.setInterceptorBatch({
  axiosInstance,
  store
});

const reqRes = import.meta.glob(`./resources/i18n/*`, { eager: true });
translator.applyAppI18n(reqRes);

app.use(router);
app.use(store);
app.use(vuetify);
app.mount('#app');
